/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Give_TitleInputs */

const en_cp_give_title = /** @type {(inputs: Cp_Give_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep gives`)
};

const id_cp_give_title = /** @type {(inputs: Cp_Give_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep memberi`)
};

/**
* | output |
* | --- |
* | "Bystep gives" |
*
* @param {Cp_Give_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_give_title = /** @type {((inputs?: Cp_Give_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Give_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_give_title(inputs)
	return en_cp_give_title(inputs)
});